import React from 'react';

import { IconLoading } from '../../assets/icon';

const DataLoader = () => {
  return (
    <div className="d-flex flex1 d-item-center d-justify-center">
      <IconLoading className="spin" />
    </div>
  );
};

DataLoader.propTypes = {};

DataLoader.defaultProps = {};

export default DataLoader;
